import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc.js'

dayjs.extend(utc)

export function formatShanghaiDateTime(value: Date | string, format = 'YYYY-MM-DD HH:mm') {
  return dayjs(value).utcOffset(8).format(format)
}

export function formatShanghaiDate(value: Date | string, format = 'YYYY-MM-DD') {
  return dayjs(value).utcOffset(8).format(format)
}
